import Http from './http';
import Vue from 'vue';
import { encryptData } from '../utils/crypto';

export default {
  // 根据报装码获取客户信息
  getSnInfo(installCode) {
    return Http.get('/v2/api/cms/client/info', { install_code: installCode });
  },
  // 上报客户信息到 cms
  postClientInfo(code, token, data) {
    // 加密敏感数据
    const encryptedData = encryptData(data);
    // 发送加密后的数据，添加 encrypted 标识
    return Http.post('/v2/api/cms/client/info', {
      encrypted: true,
      data: encryptedData
    });
  },
  // 编辑客户信息
  putClientInfo(code, token, data) {
    return Http.put('/v2/api/cms/client/info', data);
  },
  // 根据关键字获取企业信息
  getCompanyList(word) {
    return Http.get('/v2/api/cms/company/search', { word });
  },
  getIP() {
    return Vue.axios.get('https://api.ip.sb/geoip').then(res => res.data);
    // return Http.get('/v2/api/cms/client/ip');
  }
};



// WEBPACK FOOTER //
// ./src/service/cmsService.js